import React from "react";
import Text from "../../../../../../../_components/Text";
import { _Input } from "../../../../../../../_components/Input";
import { CreateNFeContext } from "../../../Context";

const options = [
  {
    label: "0=Não",
    value: "0",
  },
  {
    label: "1=Consumidor final",
    value: "1",
  },
];

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  function onChange(e) {
    const { nfe } = context;
    nfe.identification.is_final_consumer = e.value;
    context.handlers.updateNFeData(nfe);
  }
  return (
    <div className="">
      <_Input
        value={context.nfe.identification.is_final_consumer}
        onChange={onChange}
        label="Consumidor final"
        type="select"
        options={options}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/IsFinalConsumer/index.jsx